/*
=========================================================
* Material Kit 2 PRO React - v2.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Pricing page components
import FaqCollapse from "pages/Produtos/Templar/Components/FaqCollapse";

function Faq() {
  const [collapse, setCollapse] = useState(false);

  return (
    <MKBox component="section" py={6}>
      <Container>
        <Grid container justifyContent="center">
          <Grid item xs={12} md={10}>
            <Card>
              <MKBox
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                p={3}
                mt={-3}
                mx={2}
              >
                <MKTypography variant="h4" color="white">
                  Peguntas Frequentes
                </MKTypography>
                <MKTypography variant="body2" color="white" opacity={0.8}>
                  Última atualização: 19/07/2025
                </MKTypography>
              </MKBox>
              <MKBox py={2} px={3}>
                <FaqCollapse
                  title="O que é o Templar?"
                  open={collapse === 3}
                  onClick={() => (collapse === 3 ? setCollapse(false) : setCollapse(3))}
                >
                  O Templar é um data center, um centro de comunicações e uma central de controle.<br/><br/>
                  O Templar é um data center de nuvem privada portátil e robusto que pode ser usado em qualquer lugar 
                  para fornecer serviços de computação, dados e comunicação de alta potência. Ele tem dez servidores 
                  blade potentes e um centro de comunicações que lida com todos os sistemas portadores conhecidos. 
                  Com enorme capacidade de armazenamento e memória, ele pode lidar até mesmo com os aplicativos mais 
                  recentes de IA e que consomem muitos recursos.
                </FaqCollapse>
                <FaqCollapse
                  title="Como faço para adquirir o Templar?"
                  open={collapse === 1}
                  onClick={() => (collapse === 1 ? setCollapse(false) : setCollapse(1))}
                >
                  Entre em contato com a nossa equipe de vendas através do email: vendas@fmpsolucoes.com.br
                </FaqCollapse>
                <FaqCollapse
                  title="Qual o tempo de entrega?"
                  open={collapse === 2}
                  onClick={() => (collapse === 2 ? setCollapse(false) : setCollapse(2))}
                >
                  O tempo de entrega varia de acordo com a quantidade e atual fila de produção, porém geralmente as ordens são entregues em
                  até 8 semanas.
                </FaqCollapse>
                <FaqCollapse
                  title="Quais são as possibilidades de conexão simultânea?"
                  open={collapse === 4}
                  onClick={() => (collapse === 4 ? setCollapse(false) : setCollapse(4))}
                >
                  O Templar pode operar conexões ópticas, de rádio, wi-fi e satélite simultaneamente. <br/><br/>
                  Ele pode operar até 300 thin-clients e 7.200 unidades de fala, além de SATCOM e fibra óptica, tudo ao mesmo tempo. 
                  O Cradlepoint integrado suporta balanceamento de carga round-robin e direcionamento de tráfego para otimizar a 
                  utilização da largura de banda e a priorização de aplicativos.
                </FaqCollapse>
                <FaqCollapse
                  title="Em caso de falta de eletricidade, eu ainda tenho acesso aos meus dados?"
                  open={collapse === 5}
                  onClick={() => (collapse === 5 ? setCollapse(false) : setCollapse(5))}
                >
                  O Templar é vendido com duas baterias UPS, uma de 12 horas e outra de 8 horas, que podem ser utilizadas para manter os seus dados
                  e sistemas em funcionamento enquanto a fonte principal de energia está inoperante. Caso as baterias percam a carga antes de a rede
                  elétrica principal retornar ao funcionamento normal, é possível também manter o Templar em funcionamento com painéis solares de 12V
                  e também baterias automotivas.
                </FaqCollapse>
              </MKBox>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Faq;
